import { useEffect, useState } from 'react';

/** Don't show loading UI until a fetch exceeds this threshold. */
export const SLOW_LOADING_THRESHOLD_MS = 250;

/**
 * Returns true only after `isLoading` has stayed true for `delayMs`. Resets
 * immediately when loading finishes — avoids flashing loading UI on fast
 * requests without holding the indicator past completion.
 */
export function useIsLoadingSlow(
  isLoading: boolean,
  delayMs = SLOW_LOADING_THRESHOLD_MS,
): boolean {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setShow(false);
      return undefined;
    }

    const id = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(id);
  }, [isLoading, delayMs]);

  return show;
}
